import React from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, Headphones, Brain, Check } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    icon: <FolderOpen className="w-10 h-10 text-black" data-id="element-187" />,
    title: '📂 Abrís la biblioteca',
    color: 'bg-[#8FF650]'
  }, {
    icon: <Headphones className="w-10 h-10 text-white" data-id="element-188" />,
    title: '🎧 Elegís un audiolibro o ebook',
    color: 'bg-emerald-500'
  }, {
    icon: <Brain className="w-10 h-10 text-white" data-id="element-189" />,
    title: '🧠 Aprendés mientras seguís con tu día',
    color: 'bg-teal-500'
  }];
  return <section className="py-10 px-4 bg-[#F9FAFB] text-center" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-192">
          <div className="inline-block bg-[#8FF650] text-black font-black px-4 py-1 rounded-full text-sm md:text-base mb-5 uppercase tracking-widest shadow-sm" data-id="element-193">
            ✅ LA SOLUCIÓN
          </div>

          <h2 className="text-3xl md:text-5xl font-black mb-5 leading-tight text-black" data-id="element-194">
            MegaPack De 2.000 Audiolibros y 1.500 Ebooks | Sistema de
            Reprogramación Mental
          </h2>

          <p className="text-lg md:text-xl font-medium text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-195">
            Una biblioteca digital enorme diseñada para que puedas aprender y
            crecer mientras haces tu vida normal.
          </p>

          <div className="bg-white p-6 rounded-2xl border-2 border-[#8FF650] mb-8 shadow-sm" data-id="element-196">
            <p className="text-xl md:text-2xl font-black mb-2 text-gray-900" data-id="element-197">
              No necesitás más tiempo.
            </p>
            <p className="text-xl md:text-2xl font-black text-[#66C530]" data-id="element-198">
              Solo usar mejor el tiempo que ya tenés.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-199">
            {steps.map((step, index) => <motion.div key={index} whileHover={{
            scale: 1.02
          }} className="bg-white rounded-2xl p-6 border border-gray-200 flex flex-col items-center text-center shadow-sm" data-id="element-200">
                <div className={`w-20 h-20 rounded-full ${step.color} flex items-center justify-center mb-4 shadow-md`} data-id="element-201">
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-202">
                  {step.title}
                </h3>
              </motion.div>)}
          </div>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-base md:text-lg font-bold text-gray-500" data-id="element-203">
            <span className="flex items-center gap-2" data-id="element-204">
              <Check className="w-5 h-5 text-emerald-500" data-id="element-205" /> Sin estudiar horas.
            </span>
            <span className="flex items-center gap-2" data-id="element-206">
              <Check className="w-5 h-5 text-emerald-500" data-id="element-207" /> Sin cambiar tu
              rutina.
            </span>
            <span className="flex items-center gap-2" data-id="element-208">
              <Check className="w-5 h-5 text-emerald-500" data-id="element-209" /> Sin agregar tareas
              extra.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}